import { Button, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ContentBox } from "../../../components/layout/content";
import { LoginedLayout } from "../../../components/layout/loginLayout";
import { HeaderTitle } from "../../../components/styled-components";
import { GET } from "../../../services";
import { GETWAITHOLD } from "../../../services/path";

interface DataType {
  no: number;
  orderNo: string;
  SoNo: string;
  optStatusID: number;
  status: string;
  invoiceNo: string;
}

const Editskutable = () => {
  const [inputValue, setInputValue] = useState("");
  const [data, setData] = useState<DataType[]>([]);
  const navigate = useNavigate();
  const generateColumn = (
    title: string,
    dataIndex: keyof DataType,
    key: keyof DataType,
    filterable = false,
    width?: number,
  ): any => ({
    title,
    dataIndex,
    key,
    width, // Set width to ensure columns align well
    sorter: (a: DataType, b: DataType) => {
      const aValue = a[dataIndex] ?? "";
      const bValue = b[dataIndex] ?? "";
      return aValue.toString().localeCompare(bValue.toString());
    },
    ...(filterable && {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
        <div style={{ padding: 3 }}>
          <Input
            placeholder={`Search ${title}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            size="small"
            style={{ width: 50, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 50 }}>
            Reset
          </Button>
        </div>
      ),
      onFilter: (value: string, record: DataType) => {
        return record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase());
      },
    }),
  });

  const columns = [
    generateColumn("Order Number", "orderNo", "orderNo", true, 150),
    generateColumn("Sales ID", "SoNo", "SoNo", true, 150),
    generateColumn("Status", "status", "status", false, 100),
    generateColumn("Invoice", "invoiceNo", "invoiceNo", true, 150),
    {
      title: "",
      key: "",
      render: (_: string, record: DataType) => (
        <Button
          disabled={record.optStatusID !== 10}
          onClick={() =>
            navigate(`/editsku/editoneorder`, {
              state: {
                orderNumber: record.orderNo,
                no: record.no,
                soNo: record.SoNo,
              },
            })
          }
        >
          edit
        </Button>
      ),
      width: "70px",
    },
  ];

  const fetchOrder = async () => {
    try {
      const result = await GET(GETWAITHOLD); //GETWAITHOLD
      setData(result.result.filter((item: DataType) => item.optStatusID === 10));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchOrder();
  }, []);

  const handleChangeSearch = (e: any) => {
    setInputValue(e.target.value);
  };

  return (
    <LoginedLayout>
      <ContentBox>
        <HeaderTitle>
          <h2>Edit Sku</h2>
        </HeaderTitle>
        <div style={{ marginBottom: "10px" }}>
          <Input placeholder="Search Order Number" onChange={handleChangeSearch} allowClear />
        </div>
        <div>
          <Table
            dataSource={data.filter((item) => item.orderNo.includes(inputValue))}
            columns={columns}
            scroll={{ x: 750 }}
            pagination={false}
          />
        </div>
      </ContentBox>
    </LoginedLayout>
  );
};

export default Editskutable;
